module.exports = __webpack_public_path__ + "media/images/forms-icons/radio-icon-hover-7507b074bdae0f18be5e7a9befc1eaea.svg";